import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { StyleClass } from "primereact/styleclass";
import { useRef } from "react";
import { NavLink } from "react-router-dom";

const SubItem = ({
  label,
  icon,
  items,
  expanded = true,
}: {
  label: string;
  icon: string;
  items: any[];
  expanded?: boolean;
}) => {
  const btnRefs = useRef<any>(null);
  const op = useRef<OverlayPanel>(null);
  
  return expanded ? (
    <>
      <div className="mb-2" key={label}>
        <StyleClass
          nodeRef={btnRefs}
          selector="@next"
          enterClassName="hidden"
          enterActiveClassName="slidedown"
          leaveToClassName="hidden"
          leaveActiveClassName="slideup"
        >
          <div
            ref={btnRefs}
            className="submenu-header flex align-items-center justify-content-between"
          >
            <span className="flex align-items-center">
              <i className={`${icon} mr-3`} style={{ fontSize: '1.125rem' }} />
              {label}
            </span>
            <i className="pi pi-chevron-down chevron" style={{ fontSize: '0.875rem' }} />
          </div>
        </StyleClass>
        <div className="submenu-items overflow-hidden hidden">
          {items.map((subTitle: any) => (
            <NavLink
              to={subTitle.path}
              key={subTitle.path}
              className="submenu-item-link"
            >
              {({ isActive }) => (
                <div
                  className={`submenu-item flex align-items-center gap-2 ${
                    isActive ? "active" : ""
                  }`}
                >
                  <i className={subTitle.icon} />
                  <span>{subTitle.label}</span>
                </div>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </>
  ) : (
    <div>
      <Button
        className="w-full mb-1"
        type="button"
        icon={icon}
        tooltip={label}
        tooltipOptions={{ position: "right" }}
        onClick={(e) => op.current?.toggle(e)}
        text
        style={{
          padding: '0.875rem',
          borderRadius: '0.75rem',
          transition: 'all 0.3s ease'
        }}
      />
      <OverlayPanel
        ref={op}
        dismissable={false}
        onMouseLeave={(e) => op.current?.toggle(e)}
        data-pr-position="right"
        style={{
          background: 'var(--surface-card)',
          border: '2px solid var(--primary-color)',
          borderRadius: '0.75rem',
          boxShadow: '0 8px 24px rgba(249, 115, 22, 0.2)',
          minWidth: '220px',
          padding: '0.75rem'
        }}
      >
        <div className="flex flex-column">
          <div className="font-bold text-primary mb-3 pb-2 border-bottom-2 border-primary flex align-items-center gap-2" style={{ fontSize: '0.95rem' }}>
            <i className={icon} style={{ fontSize: '1.125rem' }}></i>
            {label}
          </div>
          {items.map((subTitle: any) => (
            <NavLink
              to={subTitle.path}
              key={subTitle.path}
              style={{ textDecoration: 'none' }}
            >
              {({ isActive }) => (
                <div
                  className={`submenu-overlay-item flex align-items-center gap-3 ${
                    isActive ? "active" : ""
                  }`}
                >
                  <i className={subTitle.icon} />
                  <span>{subTitle.label}</span>
                </div>
              )}
            </NavLink>
          ))}
        </div>
      </OverlayPanel>
    </div>
  );
};

export default SubItem;
